import React, {useEffect, useState} from 'react';
import ScrollableTitleImage from "../../../components/imageList/ScrollableTitleImage";
import SelectableItemList from "../../../components/list/SelectableItemList";
import {callApi} from "../../../connection/ClientApi";
import {groupedList} from "components/utils/ListUtility";
import Product from "../product/Product";
import EmptyBox from "components/emptyBox/EmptyBox";
import Pagination from "components/list/Pagination";
import {useHistory} from "react-router-dom";
import {toEnglishNumber} from "components/utils/StringUtility";
import {getSmallTextViewHeight, IsF, IsLP, IsLP_MP, IsLP_MP_SP, IsM, IsMP, IsSP, IsT} from "my-styles/media/media";
import IconTitleValue from "components/textValue/IconTitleValue";
import CustomSwitch from "components/switch/CustomSwitch";
import RangeSlider from "components/rangeSlider/RangeSlider";
import {Divider} from '@material-ui/core';
import {categoryViewModel} from "../../../viewModels/Category.viewModel";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import queryString from 'query-string';
import CustomCheckBox from "components/checkBox/CustomCheckBox";
import IconTextView from "components/input/IconTextView";

import ICExpand from "@mui/icons-material/KeyboardArrowDown";
import ICCollapse from "@mui/icons-material/KeyboardArrowUp";
import ICDelete from 'res/images/delete_blue.png';
import ICSearch from "res/images/magnifire.png";
import ICFilter from 'res/images/filter.png';
import ICSort from 'res/images/sort.png';
import { Helmet } from 'react-helmet';

export default function Category(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [minPrice] = useState(0)
    const [maxPrice] = useState(600000)
 //   const [limit] = useState((urlParams && urlParams.c) ? 16 : 15)
    const [limit] = useState( IsLP_MP() ? 15 : IsSP() ? 16 : IsT() ? 12 : IsF() ? 12 : IsM() ? 12 : 10 )
    const [pages, setPages] = useState([])
    const [products, setProducts] = useState([])
    const [showEmptyBox, setShowEmptyBox] = useState(false)

    const [isFilterExpanded, setIsFilterExpanded] = useState(false)
    const [isFilterPriceExpanded, setIsFilterPriceExpanded] = useState(false)

    const [brands, setBrands] = useState([])
    const [searchBrandText, setSearchBrandText] = useState("")
    const [isFilterBrandExpanded, setIsFilterBrandExpanded] = useState(false)
    const [isBrandListExpanded, setIsBrandListExpanded] = useState(false)


    function defaultParams() {
        let params = new FormData()
        params.append("type", urlParams.type ? urlParams.type : "0")
        params.append("category_id", urlParams.c ? urlParams.c : "")
        params.append("is_search", urlParams.searchText ? "1" : "0")
        params.append("text", urlParams.searchText ? toEnglishNumber(urlParams.searchText) : "")
        if (urlParams.b) {
            params.append("manufacturer_id", urlParams.b)
        } else if (urlParams.m) {
            params.append("manufacturer_id", urlParams.m)
        }
        params.append("filter_price", isFilterPriceSet() ? urlParams.min + "," + urlParams.max : "")
        params.append("sort", urlParams.sort ? urlParams.sort : "")
        params.append("hide_unavailable_products", urlParams.ox ? "1" : "0")
        params.append("have_discount", urlParams.od ? "1" : "0")
        return params
    }

    function requestBrands() {
        let params = new FormData()
        params.append("category_id", urlParams.c ? urlParams.c : "")
        params.append("manufacturer_id", urlParams.m ? urlParams.m : "")
        callApi(Urls.getAllManufacturer, params, (data) => {
            let tempBrands = []
            if (data && data.list) {
                for (let brand of data.list) {
                    tempBrands.push({
                        id: brand.manufacturer_id,
                        title: brand.name
                    })
                }
            }
            setBrands(tempBrands)
        }, () => {
            setBrands([])
        })
    }

    function requestGetFilterInfo() {
        let params = defaultParams()
        callApi(Urls.getProductsDefaultInfo, params, (data) => {
            if (parseInt(data.count) === 0) {
                setShowEmptyBox(true)
            } else {
                setShowEmptyBox(false)
                let number = data.count / limit
                if (data.count % limit > 0) {
                    number++
                }
                let tempPages = []
                for (let i = 1; i <= number; i++) {
                    tempPages.push({
                        number: i,
                        selected: i === parseInt(urlParams.p)
                    })
                }
                setPages(tempPages)
            }
        })
    }

    function requestGetProducts() {
        let params = defaultParams()
        params.append("limit", limit)
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        callApi(Urls.getProducts, params, (data) => {
            setProducts([])
            let products = basketViewModel.checkLocalBasket(data.list)
            let constLimit = IsLP_MP() ? 5 : IsSP() ? 4 : IsT() ? 3 : IsF() ? 2 : IsM() ? 2 : 1
            let emptyCount = constLimit - (products.length % constLimit)
            setProducts(groupedList(products, constLimit, emptyCount))

            if (isCancelled) {
            }
        }, () => {
            setProducts([])
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }


    function onNextClick() {
        pushToHistory({
            b: urlParams.b,
            min: urlParams.min,
            max: urlParams.max,
            od: urlParams.od,
            ox: urlParams.ox,
            c: urlParams.c,
            p: (parseInt(urlParams.p) + 1),
            sort: urlParams.sort,
            searchText: urlParams.searchText,
            type: urlParams.type
        })
    }

    function onBackClick() {
        pushToHistory({
            b: urlParams.b,
            min: urlParams.min,
            max: urlParams.max,
            od: urlParams.od,
            ox: urlParams.ox,
            c: urlParams.c,
            p: (parseInt(urlParams.p) - 1),
            sort: urlParams.sort,
            searchText: urlParams.searchText,
            type: urlParams.type
        })
    }

    function onNumberClick(number) {
        pushToHistory({
            b: urlParams.b,
            min: urlParams.min,
            max: urlParams.max,
            od: urlParams.od,
            ox: urlParams.ox,
            c: urlParams.c,
            p: number,
            sort: urlParams.sort,
            searchText: urlParams.searchText,
            type: urlParams.type
        })
    }

    function pushToHistory(value) {
        let path = '/category?'
        if (value.c) {
            path += 'c=' + value.c + '&'
        }
        if (value.b) {
            path += 'b=' + value.b + '&'
        }
        if (value.sort) {
            path += 'sort=' + value.sort + '&'
        }
        if (value.searchText) {
            path += 'searchText=' + value.searchText + '&'
        }
        if (value.type) {
            path += 'type=' + value.type + '&'
        }
        if (value.ox) {
            path += 'ox=' + value.ox + '&'
        }
        if (value.od) {
            path += 'od=' + value.od + '&'
        }
        if (value.min !== undefined) {
            path += 'min=' + value.min + '&'
        }
        if (value.max !== undefined) {
            path += 'max=' + value.max + '&'
        }
        if (urlParams.m) {
            path += 'm=' + urlParams.m + '&'
        }

        if (path.endsWith("&")) {
            path = path.substring(0, path.length - 1)
        }
        path += '&p=' + value.p

        props.onNavigate(history, path)
    }

    function isFilterSet() {
        return urlParams.b || urlParams.ox || urlParams.od || isFilterPriceSet()
    }

    function isFilterPriceSet() {
        return (urlParams.min && urlParams.min !== -1 && parseInt(urlParams.min) !== minPrice) ||
            (urlParams.max && urlParams.max !== -1 && parseInt(urlParams.max) !== maxPrice)
    }

    function isBrandSelected(brand) {
        if (urlParams.b) {
            let brandIds = urlParams.b.split(",")
            for (let id of brandIds) {
                if (brand.id === id) {
                    return true
                }
            }
        }
    }

    function getFilterCount() {
        let count = 0
        if (isFilterPriceSet()) {
            count++
        }
        if (urlParams.ox) {
            count++
        }
        if (urlParams.od) {
            count++
        }
        if (urlParams.b) {
            count++
        }
        return count
    }

    function getBrandList() {
        if (searchBrandText.length > 0) {
            return brands.filter((brand) => brand.title.indexOf(searchBrandText) !== -1)
        }
        return brands
    }

    function getSelectedBrandString() {
        let selectedBrandString = ""
        if (urlParams.b) {
            for (let brand of brands) {
                if (isBrandSelected(brand)) {
                    if (selectedBrandString.length > 0) {
                        selectedBrandString = selectedBrandString + "Ø "
                    }
                    selectedBrandString = selectedBrandString + brand.title
                }
            }
        }
        return selectedBrandString
    }


    function sort() {
        return <div className="marginTopBottomSmall fullWidth">
            <div className="horizontalFullScreen">
                <IconTitleValue
                    titleClassName={"mediumTextBold blueColor_8"}
                    icon={<img alt="sort" src={ICSort} className="xSmallIcon marginTopSmall marginRightSmall"/>}
                    title={messages.sort}/>
                <div className="marginTopXSmall fullWidth" style={{overflow: "hidden"}}>
                    <SelectableItemList
                        shadow={"0px"}
                        items={[
                            {title: messages.newest, id: 1, selected: urlParams && parseInt(urlParams.sort) === 1},
                            {title: messages.lowCost, id: 2, selected: urlParams && parseInt(urlParams.sort) === 2},
                            {title: messages.highCost, id: 3, selected: urlParams && parseInt(urlParams.sort) === 3},
                            {title: messages.famous, id: 4, selected: urlParams && parseInt(urlParams.sort) === 4},
                            {title: messages.highDiscount, id: 5, selected: urlParams && parseInt(urlParams.sort) === 5}
                        ]}
                        fontSize={"smallTextBold"}
                        itemsPerView={IsLP() ? 8 : IsMP() ? 7 : IsSP() ? 5 : 0}
                        onItemSelected={(index, item) => {
                            pushToHistory({
                                b: urlParams.b,
                                min: urlParams.min,
                                max: urlParams.max,
                                od: urlParams.od,
                                ox: urlParams.ox,
                                c: urlParams.c,
                                p: 1,
                                sort: item.id,
                                searchText: urlParams.searchText,
                                type: urlParams.type
                            })
                        }}/>
                </div>
            </div>
        </div>
    }

    function filterHeader() {
        return <div className="marginTopSmall fullWidth">
            <div className="horizontalFullScreen">
                <div className="fullWidth">
                    <IconTitleValue
                        badgenumber={getFilterCount()}
                        titleClassName={"mediumTextBold blueColor_8"}
                        icon={<img alt="filter" src={ICFilter} className="xSmallIcon marginTopSmall marginRightSmall"/>}
                        title={messages.filter}/>
                </div>
                {isFilterSet() &&
                <IconTitleValue
                    titleClassName={"mediumTextBold blueColor_8"}
                    icon={<img alt="delete" src={ICDelete} className="xxSmallIcon marginTopXSmall blueColor_8"/>}
                    title={IsLP_MP_SP() ? messages.deleteFilters : ""}
                    onClick={() => {
                        pushToHistory({
                            b: "",
                            min: minPrice,
                            max: maxPrice,
                            od: false,
                            ox: false,
                            c: urlParams.c,
                            p: 1,
                            sort: urlParams.sort,
                            searchText: urlParams.searchText,
                            type: urlParams.type
                        })
                        setSearchBrandText("")
                        setIsFilterExpanded(false)
                        setIsFilterBrandExpanded(false)
                        setIsFilterPriceExpanded(false)
                    }}/>
                }
                {!IsLP_MP_SP() &&
                <IconTitleValue
                    titleClassName={"mediumTextBold blueColor_8"}
                    icon={isFilterExpanded ?
                        <ICCollapse className="marginTopSmall blueColor_8"/> :
                        <ICExpand className="marginTopSmall blueColor_8"/>
                    }
                    onClick={() => {
                        setIsFilterExpanded(!isFilterExpanded)
                        setIsFilterBrandExpanded(false)
                        setIsFilterPriceExpanded(false)
                    }}/>
                }
            </div>
        </div>
    }

    function filter() {
        return <div className="fullWidth">
            <div className="marginLeftRightMedium">
                <IconTitleValue
                    flip={true}
                    fullWidth={true}
                    title={messages.brand}
                    titleClassName={"mediumTextBold fullWidth"}
                    icon={isFilterBrandExpanded ?
                        <ICCollapse className="marginTopSmall"/> :
                        <ICExpand className="marginTopSmall"/>
                    }
                    onClick={() => {
                        setIsFilterBrandExpanded(!isFilterBrandExpanded)
                    }}/>

                {urlParams.b && !isFilterBrandExpanded &&
                <div className="marginLeftRightMedium smallTextBold greenColor">
                    {getSelectedBrandString()}
                </div>
                }
                {brands && brands.length > 0 && isFilterBrandExpanded &&
                <div style={{position: "relative"}}>
                    <IconTextView
                        className={"inputBoxBordered"}
                        height={getSmallTextViewHeight()}
                        placeholder={messages.searchBrand}
                        icon={<img alt={"search"} src={ICSearch} className="marginSmall xSmallIcon"/>}
                        onChange={(e) => {
                            setSearchBrandText(e.target.value)
                        }}/>
                    <div className="side_scroll" style={{maxHeight: "25em", direction: "rtl"}}>
                        {getBrandList().map((item, index) => {
                            if (index >= 5 && !isBrandListExpanded) {
                                return <></>
                            }
                            return <CustomCheckBox
                                key={index}
                                label={item.title}
                                checked={isBrandSelected(item)}
                                className="mediumTextBold"
                                checkboxcolor={"var(--green_2)"}
                                onClick={() => {
                                    let brandIdsString = ""
                                    if (urlParams.b) {
                                        let brandIds = urlParams.b.split(",")
                                        if (brandIds.filter((id) => id === item.id).length > 0) {
                                            brandIds = brandIds.filter((id) => id !== item.id)
                                        } else {
                                            brandIds.push(item.id)
                                        }
                                        for (let brandId of brandIds) {
                                            if (brandIdsString !== "") {
                                                brandIdsString = brandIdsString + ","
                                            }
                                            brandIdsString = brandIdsString + brandId
                                        }
                                    } else {
                                        brandIdsString = item.id
                                    }
                                    pushToHistory({
                                        b: brandIdsString,
                                        min: urlParams.min,
                                        max: urlParams.max,
                                        od: urlParams.od,
                                        ox: urlParams.ox,
                                        c: urlParams.c,
                                        p: 1,
                                        sort: urlParams.sort,
                                        searchText: urlParams.searchText,
                                        type: urlParams.type
                                    })
                                }}/>
                        })}
                    </div>
                    {getBrandList().length > 5 &&
                    <div style={{marginRight: "30%"}}>
                        <IconTitleValue
                            titleClassName={"smallTextBold blackColor"}
                            icon={isBrandListExpanded ?
                                <ICCollapse className="marginTopSmall blackColor"/> :
                                <ICExpand className="marginTopSmall blackColor"/>
                            }
                            title={isBrandListExpanded ? messages.seeLess : messages.seeMore}
                            onClick={() => {
                                setIsBrandListExpanded(!isBrandListExpanded)
                            }}/>
                    </div>
                    }
                </div>
                }
            </div>
            <div className="marginLeftRightMedium marginTopSmall">
                <IconTitleValue
                    titleClassName={"mediumTextBold fullWidth"}
                    icon={isFilterPriceExpanded ?
                        <ICCollapse className="marginTopSmall"/> :
                        <ICExpand className="marginTopSmall"/>
                    }
                    flip={true}
                    fullWidth={true}
                    title={messages.priceRange}
                    onClick={() => {
                        setIsFilterPriceExpanded(!isFilterPriceExpanded)
                    }}/>
                {isFilterPriceSet() && !isFilterPriceExpanded &&
                <div className="marginLeftRightMedium smallTextBold greenColor">
                    {messages.from + " " + parseInt(urlParams.min).toLocaleString() + " " + messages.to + " " + parseInt(urlParams.max).toLocaleString() + " " + messages.priceUnit}
                </div>
                }
                {isFilterPriceExpanded &&
                <RangeSlider
                    initMin={minPrice}
                    initMax={maxPrice}
                    selectedMin={urlParams.min && urlParams.min !== -1 ? urlParams.min : minPrice}
                    selectedMax={urlParams.max && urlParams.max !== -1 ? urlParams.max : maxPrice}
                    style={{width: "60%", marginRight: "20%"}}
                    onChangeCommitted={(value) => {
                        pushToHistory({
                            b: urlParams.b,
                            min: value.min,
                            max: value.max,
                            od: urlParams.od,
                            ox: urlParams.ox,
                            c: urlParams.c,
                            p: 1,
                            sort: urlParams.sort,
                            searchText: urlParams.searchText,
                            type: urlParams.type
                        })
                    }}/>
                }
            </div>
            <div className="verticalInWebHorizontalInMobile">
                <div className="marginRightMedium marginTopSmall">
                    <CustomSwitch
                        checked={urlParams.ox}
                        text={messages.onlyExistProduct}
                        onChange={() => {
                            pushToHistory({
                                b: urlParams.b,
                                min: urlParams.min,
                                max: urlParams.max,
                                od: urlParams.od,
                                ox: !urlParams.ox,
                                c: urlParams.c,
                                p: 1,
                                sort: urlParams.sort,
                                searchText: urlParams.searchText,
                                type: urlParams.type
                            })
                        }}/>
                </div>
                <div className="marginRightMedium marginTopSmall">
                    <CustomSwitch
                        checked={urlParams.od}
                        text={messages.onlyDiscountProduct}
                        onChange={() => {
                            pushToHistory({
                                b: urlParams.b,
                                min: urlParams.min,
                                max: urlParams.max,
                                od: !urlParams.od,
                                ox: urlParams.ox,
                                c: urlParams.c,
                                p: 1,
                                sort: urlParams.sort,
                                searchText: urlParams.searchText,
                                type: urlParams.type
                            })
                        }}/>
                </div>
            </div>
        </div>
    }

    function categoryChildList() {
        let selectedCategory = categoryViewModel.getCategoryById(urlParams.c)
        if (selectedCategory) {
            return <div>
                <ScrollableTitleImage
                    itemWidth={"10em"}
                    items={
                        selectedCategory.childs.map((categoryChild) => {
                            return {
                                title: categoryChild.title,
                                image: categoryChild.image,
                                selected: categoryChild.id === urlParams.c,
                                onClick: () => {
                                    categoryViewModel.setSelectedCategoryChild(categoryChild)
                                    setBrands([])
                                    setSearchBrandText("")
                                    pushToHistory({
                                        min: urlParams.min,
                                        max: urlParams.max,
                                        od: urlParams.od,
                                        ox: urlParams.ox,
                                        c: categoryChild.id,
                                        p: 1,
                                        sort: urlParams.sort,
                                        searchText: urlParams.searchText,
                                        type: urlParams.type
                                    })
                                }
                            }
                        })
                    }
                    itemsPerView={IsLP_MP() ? 7 : IsSP() ? 6 : IsT() ? 5 : 4}/>
                <Divider/>
            </div>
        }
    }

    function productList() {
        if (products.length > 0) {
            return <div>
                <div>
                    {products.map((productGroup, index) => {
                        return (<div key={index} className="horizontalFullScreen center">
                            {productGroup.map((product, index1) => {
                                return <div key={index1} className="categoryProduct">
                                    <Product {...props} data={product}/>
                                </div>
                            })}
                        </div>)
                    })}
                </div>
                {pages.length > 0 &&
                <div style={{float: "left"}}>
                    <br/>
                    <Pagination
                        pages={pages}
                        onNumberClick={onNumberClick}
                        onNextClick={onNextClick}
                        onBackClick={onBackClick}/>
                </div>
                }
            </div>
        }
    }


    useEffect(() => {
        requestGetProducts()
        requestGetFilterInfo()
        requestBrands()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (<div>
        <Helmet>
            <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - Ø¯Ø³ØªÙ Ø¨ÙØ¯Û ÙØ­ØµÙÙØ§Øª</title>
            <meta name="description" content="ÙÛØ³Øª ÙØ­ØµÙÙØ§Øª ÙØ§ Ø¨Ø± Ø§Ø³Ø§ Ø¯Ø³ØªÙ Ø¨ÙØ¯Û Ø§ÙØªØ®Ø§Ø¨Û Ø´ÙØ§ "/>
            <meta property="og:title" content="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - Ø¯Ø³ØªÙ Ø¨ÙØ¯Û ÙØ­ØµÙÙØ§Øª"/>
            <meta property="og:description" content="ÙÛØ³Øª ÙØ­ØµÙÙØ§Øª ÙØ§ Ø¨Ø± Ø§Ø³Ø§ Ø¯Ø³ØªÙ Ø¨ÙØ¯Û Ø§ÙØªØ®Ø§Ø¨Û Ø´ÙØ§ "/>
            <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
            <meta property="og:url" content="https://sarfemarket.ir/"/>
            <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
        </Helmet>
        {IsLP_MP_SP() &&
            <div>
                <div className="horizontalFullScreen">
                <div className="oneFromFour">
                    {filterHeader()}
                </div>
                <div>
                    <Divider orientation={"vertical"}/>
                </div>
                <div className="threeFromFour">
                    {urlParams && urlParams.type !== "2" && sort()}
                </div>
            </div>
            <Divider/>
            <div className="fullWidth horizontalFullScreen">
                <div className="oneFromFour">
                    {filter()}
                </div>
                <div>
                    <Divider orientation={"vertical"}/>
                </div>
                <div className="threeFromFour">
                    {(urlParams && urlParams.c) && categoryChildList()}
                    {productList()}
                    {showEmptyBox &&
                    <div className="marginTopBottomMedium">
                        <EmptyBox message={messages.productListEmpty}/>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        {!IsLP_MP_SP() &&
        <div className="paddingTopSmall">
            {urlParams && urlParams.type !== "2" && sort()}
            <Divider/>
            {filterHeader()}
            <Divider/>
            {isFilterExpanded && filter()}
            <Divider/>
            <div className={urlParams && urlParams.c ? "threeFromFourInWebFullInMobile" : "fullWidth"}>
                {(urlParams && urlParams.c) && categoryChildList()}
                {productList()}
                {showEmptyBox &&
                <div className="marginTopBottomMedium">
                    <EmptyBox message={messages.productListEmpty}/>
                </div>
                }
            </div>
        </div>
        }
    </div>)

}